module.exports = __webpack_public_path__ + "src/assets/img/share/8e56f4ef5319c88fb9469e8432ffddd3.png";